export enum InviteeMeetingInvitaionStatus {
    Pending= 0,
    Accept = 1,
    Reject = 2,
    Delegate= 3
}
